/* IMPORT ENTITIES AND RESOLVERS */
import { entities as PartnerSettingEntities, resolvers as PartnerSettingResolvers } from './partner-setting'
import { entities as SettingEntities, resolvers as SettingResolvers } from './setting'

/* EXPORT ENTITY TYPES */
export * from './partner-setting/partner-setting'
export * from './setting/setting'

/* EXPORT TYPES */
export * from './partner-setting/partner-setting-type'
export * from './setting/setting-type'

export const entities = [
  /* ENTITIES */
  ...PartnerSettingEntities,
  ...SettingEntities
]

export const schema = {
  resolverClasses: [
    /* RESOLVER CLASSES */
    ...PartnerSettingResolvers,
    ...SettingResolvers
  ]
}
